import BaixarCotacao from "./BaixarCotacao";
import Multiselect from "./Multiselect";
import NivelAlto from "./NivelAlto";
import NivelBaixo from "./NivelBaixo";
import NivelElevado from "./NivelElevado";
import NivelMedio from "./NivelMedio";
import NivelOrdinario from "./NivelOrdinario";
import PastasDeArquivos from "./PastasDeArquivos";
import TrayArrowUp from "./TrayArrowUp";
import Circulos from "./Circulos";
import Colunas from "./Colunas";
import Maximixar from "./Maximixar";
import SetaParaDireita from "./SetaParaDireita";
import ArrowTopRightThinCircleOutline from "./ArrowTopRightThinCircleOutline";
import MicrosoftExcel from "./MicrosoftExcel";
import Filial from "./Filial";
import Empresa from "./Empresa";
import PizzaGraph from "./PizzaGraph";
import BoxPlus from "./BoxPlus";
import Boxes from "./Boxes";
import Grid1x2 from "./Grid1x2";
import CashSync from "./CashSync"
import CartCheck from "./CartCheck";
import StorefrontCheck from "./StorefrontCheck";
import StoreCheck from "./StoreCheck";
import HomeSwitchOutline from "./HomeSwitchOutline";
import BaixarArquivo from "./BaixarArquivo";
import MessageTextLines from "./MessageTextLines";
import ListSimple from "./ListSimple";
import StoreSearch from "./StoreSearch";
import Excel from "./Excel";
import TextBoxCheckOutline from "./TextBoxCheckOutline";
import EyeRefresh from "./EyeRefresh";
import NotebookEdit from "./NotebookEdit";
import PackageVariantClosedRemove from "./PackageVariantClosedRemove";
import PackageVariantClosedCheck from "./PackageVariantClosedCheck";
import PackageVariantClosedPlus from "./PackageVariantClosedPlus";
import TruckRemove from "./TruckRemove";
import FilterCog from "./FilterCog";
import Link from "./Link";
import ViewGallery from "./ViewGallery";
import ClipboardTextClock from './ClipboardTextClock';
import TimerAlert from './TimerAlert';
import CalendarStarFourPoints from './CalendarStarFourPoints';
import OrderAlphabeticalAscending from './OrderAlphabeticalAscending';
import OrderAlphabeticalDescending from './OrderAlphabeticalDescending';
import ProjecaoVendasPersonalizada from './ProjecaoVendasPersonalizada';
import InformationVariantCircleOutline from './InformationVariantCircleOutline';
import CogPlayOutline from './CogPlayOutline';
import Cog from './Cog';
import StarCogOutline from "./StarCogOutline";
import ChartSankeyVariant from './ChartSankeyVariant';
import BatteryPlus from './BatteryPlus';
import HomeBattery from './HomeBattery';
import Notepad from './Notepad';
import NotepadFill from './NotepadFill';
import X from './X';
import PencilSimple from './PencilSimple.vue';
import Trash from './Trash.vue';
import Plus from './Plus.vue';
import MagnifyingGlass from './MagnifyingGlass.vue';
import ArrowsDownUp from './ArrowsDownUp.vue';
import Storefront from './Storefront.vue';
import PuzzlePiece from './PuzzlePiece.vue';
import Funnel from './Funnel.vue';
import FunnelFill from './FunnelFill.vue';
import CaretDown from './CaretDown.vue';
import CaretRight from './CaretRight.vue';
import ArrowRight from "@/components/utils/icones/ArrowRight.vue";
import DownloadSimple from './DownloadSimple.vue';
import UploadSimple from './UploadSimple.vue';
import CloudArrowUp from './CloudArrowUp.vue';
import FileXls from './FileXls.vue';
import XCircle from './XCircle.vue';
import WarningOctagon from './WarningOctagon.vue';
import CheckCircle from './CheckCircle.vue';
import Warning from './Warning.vue';
import PencilSimpleLine from './PencilSimpleLine.vue';
import Info from './Info.vue';
import Swap from './Swap.vue';
import ArrowElbowRight from './ArrowElbowRight.vue';
import ArrowLineDownLeft from './ArrowLineDownLeft.vue';
import ClockCounterClockwise from './ClockCounterClockwise.vue';
import ArrowLeft from './ArrowLeft.vue';
import Basket from './Basket.vue';
import WarningCircle from './WarningCircle.vue';
import FloppyDisk from './FloppyDisk.vue';
import CalendarBlank from './CalendarBlank.vue';
import FileText from './FileText.vue';
import Lightning from './Lightning.vue';
import Percent from './Percent.vue';
import MinusCircle from './MinusCircle.vue';
import ProjectorScreenChart from './ProjectorScreenChart.vue';
import MegaphoneSimple from './MegaphoneSimple.vue';
import Clock from './Clock.vue';
import ListPlus from './ListPlus.vue';
import DotsSixVertical from './DotsSixVertical.vue';
import DotsThree from './DotsThree.vue';

export default [
  StarCogOutline,
  InformationVariantCircleOutline,
  ChartSankeyVariant,
  CalendarStarFourPoints,
  BaixarCotacao,
  Multiselect,
  NivelElevado,
  NivelAlto,
  NivelMedio,
  NivelBaixo,
  NivelOrdinario,
  PastasDeArquivos,
  TrayArrowUp,
  Circulos,
  Colunas,
  Maximixar,
  SetaParaDireita,
  ArrowTopRightThinCircleOutline,
  MicrosoftExcel,
  Filial,
  Empresa,
  PizzaGraph,
  Boxes,
  BoxPlus,
  Grid1x2,
  CashSync,
  CartCheck,
  StorefrontCheck,
  StoreCheck,
  HomeSwitchOutline,
  BaixarArquivo,
  MessageTextLines,
  ListSimple,
  StoreSearch,
  Excel,
  TextBoxCheckOutline,
  EyeRefresh,
  NotebookEdit,
  PackageVariantClosedRemove,
  PackageVariantClosedCheck,
  PackageVariantClosedPlus,
  TruckRemove,
  FilterCog,
  Link,
  ViewGallery,
  ClipboardTextClock,
  TimerAlert,
  OrderAlphabeticalAscending,
  OrderAlphabeticalDescending,
  CogPlayOutline,
  Cog,
  BatteryPlus,
  ProjecaoVendasPersonalizada,
  HomeBattery,
  Notepad,
  NotepadFill,
  X,
  PencilSimple,
  Trash,
  Plus,
  MagnifyingGlass,
  ArrowsDownUp,
  Storefront,
  PuzzlePiece,
  Funnel,
  FunnelFill,
  CaretDown,
  CaretRight,
  ArrowRight,
  CaretRight,
  DownloadSimple,
  UploadSimple,
  CloudArrowUp,
  FileXls,
  XCircle,
  WarningOctagon,
  CheckCircle,
  Warning,
  PencilSimpleLine,
  Info,
  Swap,
  ArrowElbowRight,
  ArrowLineDownLeft,
  ClockCounterClockwise,
  ArrowLeft,
  Basket,
  WarningCircle,
  FloppyDisk,
  CalendarBlank,
  FileText,
  Lightning,
  Percent,
  MinusCircle,
  ProjectorScreenChart,
  MegaphoneSimple,
  Clock,
  ClockCounterClockwise,
  ListPlus,
  DotsSixVertical,
  DotsThree
];
